module.exports = {"line1":"<span class='bold'>הם מגש הכסף שעליו ניתנה לנו המדינה, הם המחיר הכבד ששילמנו במהלך 70 שנות עצמאות. </span>","line2":"<span class='bold'>אלה הם הדברים האחרונים שהותירו אחריהם: </span>","line3":"תמונה, ציור, שיר, מכתב מהחזית או שיחה שעדיין מהדהדת - ","line4":"מ-1948 ועד היום, סיפור על חלל אחד בכל שנה, ועל הכאב שלא מרפה.<br>","line5":"<span class='bold'>פרויקט מיוחד ליום הזיכרון</span> | נעה חסלוביצר-קולודני"}


//////////////////
// WEBPACK FOOTER
// ./src/api/Welcome.json
// module id = 109
// module chunks = 0